import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByocCourseDirective } from './course.directive';

@NgModule({
    imports: [CommonModule, ByocCourseDirective],
    exports: [ByocCourseDirective],
})
export class DirectiveCourseModule {}
